<template>
  <!-- z-50 prevent overflowing by footer,
       in next releases (toggleable menu should be postion:absolute/relative in mobile/tablet viewport instead of being flex-item) -->
  <header class="sticky top-0 z-50">
    <app-navbar />
  </header>
</template>

<script>
import AppNavbar from "@/components/AppNavbar";
export default {
  name: "AppHeader",
  components: { AppNavbar },
};
</script>

<style scoped></style>
